import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateUsuariosListaColumns
 */

type Props = {
  idUsuario: number,
  onActionEdit: (idUsuario: number | null, openNewTab: boolean) => void,
  onActionDelete: (idUsuario: number | null, openState: boolean) => void,
  onActionBlock: (idUsuario: number | null, openState: boolean) => void,
};

export const GenerateUsuariosListaColumns = ({
  idUsuario,
  onActionEdit,
  onActionDelete,
  onActionBlock,

}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case false:
        return "Ativo";
      case true:
        return "Bloqueado";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case false:
        return "green";
      case true:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
      case false:
        return "Ativo";
      case true:
        return "Bloqueado";
      default:
        return "?";
    }
  };

  return [
    {
      field: "bloqueado",
      filterable: false,
      headerName: "Status",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-start items-center break-normal">
          {params.value ?? ""}
        </div>
      )
    },
    {
      field: "login",
      filterable: false,
      headerName: "Login",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-start items-center break-all">
          {params.value ?? ""}
        </div>
      )
    },
    {
      field: "email",
      filterable: false,
      headerName: "Email",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-start items-center break-all">
          {params.value ?? ""}
        </div>
      )
    },
    {
      field: "funcionarioNome",
      filterable: false,
      headerName: "Funcionário",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-start items-center break-normal">
          {params.value ?? ""}
        </div>
      )
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data Cadastro",
      minWidth: 80,
      sortable: false,
      valueFormatter: (params) => {
        if (!params) return "";
        return new Intl.DateTimeFormat("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).format(new Date(params));
      },
    },
    {
      field: "dataBloqueio",
      filterable: false,
      headerName: "Data Bloqueio",
      minWidth: 80,
      sortable: false,
      valueFormatter: (params) => {
        if (!params) return "";
        return new Intl.DateTimeFormat("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }).format(new Date(params));
      },
    },
    {
      field: 'idUsuario',
      headerName: 'Ações',
      flex: 0,
      minWidth: 110,
      sortable: false,
      filterable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full " >
            <IconButton
              disabled={idUsuario !== 1 && params.value === 1}
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEdit(params.value, true);
                } else {
                  onActionEdit(params.value, e.ctrlKey);
                }
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>
            <IconButton
              disabled={idUsuario !== 1 && params.value === 1}
              onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
            <IconButton
              disabled={idUsuario !== 1 && params.value === 1}
              onClick={() => onActionBlock(params.value, true)}>
              <DynamicIcon nameIcon="BlockRounded" size={25} className="text-yellow-500" />
            </IconButton>
          </div>
        )
      },
    }
  ];
}